import { render, staticRenderFns } from "./MdfeTable.vue?vue&type=template&id=581a02a6&"
import script from "./MdfeTable.vue?vue&type=script&lang=js&"
export * from "./MdfeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports